function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32ZM32 4C16.536 4 4 16.536 4 32C4 47.464 16.536 60 32 60C47.464 60 60 47.464 60 32C60 16.536 47.464 4 32 4ZM49.2402 16.6415C50.1067 17.3265 50.254 18.5842 49.5691 19.4508L28.6648 45.899C27.7265 47.1226 26.2568 47.8211 24.7146 47.775C23.1742 47.729 21.7503 46.9458 20.8864 45.6709L14.3651 36.4159C13.7289 35.513 13.9451 34.2653 14.848 33.629C15.7509 32.9928 16.9987 33.209 17.6349 34.1119L24.1682 43.3839L24.1953 43.4233C24.3386 43.6374 24.5765 43.7691 24.834 43.7768C25.0916 43.7844 25.3369 43.6672 25.4928 43.4621L25.5163 43.4318L46.4309 16.9704C47.1159 16.1039 48.3736 15.9566 49.2402 16.6415Z",
  fill: "#48DBB4"
});

const SvgSuccess = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "success-icon",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/success.17a15538.svg";
export { ForwardRef as ReactComponent };